"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const logrocket_1 = tslib_1.__importDefault(require("logrocket"));
const hooks_1 = require("./");
const react_1 = require("react");
exports.useLogRocket = () => {
    var _a, _b, _c;
    const { currentUser, adminRole } = hooks_1.useOsmosysContext();
    const isLoggedIn = !!currentUser;
    react_1.useEffect(() => {
        var _a, _b, _c;
        if (isLoggedIn) {
            logrocket_1.default.identify(`${(_a = currentUser) === null || _a === void 0 ? void 0 : _a.id}`, {
                adminRole: adminRole,
                email: (_b = currentUser) === null || _b === void 0 ? void 0 : _b.email,
                name: (_c = currentUser) === null || _c === void 0 ? void 0 : _c.fullName,
            });
        }
    }, [
        isLoggedIn,
        adminRole,
        (_a = currentUser) === null || _a === void 0 ? void 0 : _a.id,
        (_b = currentUser) === null || _b === void 0 ? void 0 : _b.fullName,
        (_c = currentUser) === null || _c === void 0 ? void 0 : _c.email,
    ]);
};
//# sourceMappingURL=useLogRocket.js.map